export default {
  top_projects: "TOP проекты".toUpperCase(),
  show_more: "больше".toUpperCase(),
};
